import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AdminPanelAccessService } from '../services/admin-panel-access.service';
import { PendingMessageService } from '../services/pending-message.service';
import { ConfigService } from '../services/config.service';

export const adminPanelAccessGuard: CanActivateFn = () => {
  const accessService = inject(AdminPanelAccessService);
  const pendingMessage = inject(PendingMessageService);
  const router = inject(Router);
  const configService = inject(ConfigService);
  const isDebugEnabled = configService.isDebugEnabled();

  if (isDebugEnabled) {
    console.log('[adminPanelAccessGuard] Validando acesso ao painel administrativo');
  }

  return accessService.getAccess().pipe(
    map((result) => {
      if (isDebugEnabled) {
        console.log('[adminPanelAccessGuard] Resultado recebido', {
          canAccessAdminPanel: result.canAccessAdminPanel
        });
      }

      if (result.canAccessAdminPanel) {
        if (isDebugEnabled) {
          console.log('[adminPanelAccessGuard] Acesso permitido');
        }
        return true;
      }

      if (isDebugEnabled) {
        console.warn('[adminPanelAccessGuard] Acesso negado. Redirecionando para /dashboard');
      }
      pendingMessage.set('Usuário sem permissão de acesso ao cadastro de campanhas.');
      return router.createUrlTree(['/dashboard']);
    }),
    catchError((error) => {
      if (isDebugEnabled) {
        console.warn('[adminPanelAccessGuard] Erro ao validar acesso', {
          status: error?.status,
          message: error?.message
        });
      }
      pendingMessage.set('Não foi possível validar acesso ao cadastro de campanhas.');
      return of(router.createUrlTree(['/dashboard']));
    })
  );
};
